import reducer from './reducers';

export { default as publisherSagas } from './sagas';
export { default as publisherActions } from './actions';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/publisher/index.js